import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import Application from './components/Application.jsx';

ReactDOM.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>,
  document.getElementById('root')
);
